/**
 * Repeat prescription form
 */
const modifyField = ({ field, inputClass }) => {
  const label = field.querySelector("label");
  label.classList.add("nhsuk-label--s", "nhsuk-u-margin-bottom-3");
  const input = field.querySelector("input");
  input.classList.add(inputClass);
  return;
};

const createFieldset = ({ item = 1, total = 10 }) => {
  const fieldset = Object.assign(document.createElement("fieldset"), {
    className: "nhsuk-fieldset nhsuk-u-padding-bottom-5",
  });
  fieldset.append(
    Object.assign(document.createElement("legend"), {
      className: "nhsuk-fieldset__legend nhsuk-fieldset__legend--m",
      innerHTML: `Item ${item} of ${total}`,
    })
  );
  return fieldset;
};

const repeatPrescriptionForm = (el) => {
  const columns = el.classList.contains("frm_meds_4") ? 4 : 3;
  const fields = el.getElementsByClassName("sr_only_label");
  const rows = fields.length / columns;

  for (let i = 0; i < rows; i++) {
    let itemFieldset = createFieldset({
      item: i + 1,
      total: rows,
    });

    let firstField = fields[i * columns];
    let secondField = fields[i * columns + 1];
    let thirdField = fields[i * columns + 2];
    // optional
    let fourthField = fields[i * columns + 3];
    modifyField({
      field: firstField,
      inputClass: "hsuk-u-width-three-quarters",
    });

    modifyField({
      field: secondField,
      inputClass: "nhsuk-u-width-one-half",
    });

    modifyField({
      field: thirdField,
      inputClass: "nhsuk-input--width-10",
    });
    firstField.before(itemFieldset);
    itemFieldset.append(firstField, secondField, thirdField);
    if (columns > 3) {
      modifyField({
        field: fourthField,
        inputClass: "nhsuk-input--width-10",
      });
      itemFieldset.append(fourthField);
    }
  }
};

export default repeatPrescriptionForm;
